import { convertValues } from "./utils";

export const columnTypesList = [
  { id: "Currency", text: "Currency" },
  { id: "Date", text: "Date" },
  { id: "Email", text: "Email" },
  { id: "Number", text: "Number" },
  { id: "Picklist", text: "Picklist" },
  { id: "Picklist-Multiselect", text: "Picklist-Multiselect" },
  { id: "Text", text: "Text" },
  { id: "Textarea", text: "Textarea" },
];

export const totalCostGraphData = [
  {
    value: 30,
    name: "Internal Cost",
  },
  {
    value: 70,
    name: "Vendor Cost",
  },
];

export const totalBudgetGraphData = [
  {
    value: 52000,
    name: "Total Budget",
  },
  {
    value: 43000,
    name: "Projected Cost",
  },
  {
    value: 31000,
    name: "Amount Used",
  },
];

export const totalBudgetTableData = [
  {
    value: 52000,
    name: "Total Budget",
  },
  {
    value: 8770,
    name: "Remaining",
  },
  {
    value: 8.1,
    name: "Currently",
  },
];

export const filterSearchTypeList = [
  {
    id: "Equals",
    text: "Equals",
  },
  {
    id: "Does Not Equal",
    text: "Does Not Equal",
  },
  {
    id: "Begins With",
    text: "Begins With",
  },
  {
    id: "Ends With",
    text: "Ends With",
  },
  {
    id: "Contains",
    text: "Contains",
  },
  {
    id: "Does Not Contains",
    text: "Does Not Contains",
  },
];

export const filterSearchTypeListNumbers = [
  {
    id: "Equals",
    text: "Equals",
  },
  {
    id: "Does Not Equal",
    text: "Does Not Equal",
  },
  {
    id: "Less Than",
    text: "Less Than",
  },
  {
    id: "Less Than or Equal",
    text: "Less Than or Equal",
  },
  {
    id: "Greater Than",
    text: "Greater Than",
  },
  {
    id: "Greater Than or Equal",
    text: "Greater Than or Equal",
  },
];

export const projectAnalysisData = [
  {
    projectName: "Migrating MPLS or SD-WAN to SASE",
    projectOwner: "Kanishk",
    status: "Not Started",
    progress: 0,
    startDate: "02/25/2023",
    endDate: "08/10/2023",
    daysLeft: 171,
    group: "R&D",
    createdOn: "02/20/2023",
    modifiedOn: "02/20/2023",
    createdBy: "Puneet Gaur",
    modifiedBy: "Himanshu Bajpai",
    actualStartDate: "02/25/2023",
    actualEndDate: "12/10/2023",
    priority: "High",
    budget: 10000000,
    cost: 10000000,
    team: [],
  },
  {
    projectName: "Building Cloud Native Connectivity",
    projectOwner: "Akshay",
    status: "At Risk",
    progress: 30,
    startDate: "01/10/2023",
    endDate: "12/10/2023",
    daysLeft: 293,
    group: "Customer Delivery",
    createdOn: "01/03/2023",
    modifiedOn: "01/12/2023",
    createdBy: "Puneet Gaur",
    modifiedBy: "Himanshu Bajpai",
    actualStartDate: "01/25/2023",
    actualEndDate: "12/28/2023",
    priority: "Low",
    budget: 15000000,
    cost: 15000000,
    team: [],
  },
  {
    projectName: "Full Security Stack in the Cloud",
    projectOwner: "Ashok",
    status: "On Track",
    progress: 57,
    startDate: "01/10/2023",
    endDate: "12/10/2023",
    daysLeft: 293,
    group: "Customer Delivery",
    createdOn: "01/03/2023",
    modifiedOn: "01/12/2023",
    createdBy: "Puneet Gaur",
    modifiedBy: "Himanshu Bajpai",
    actualStartDate: "01/25/2023",
    actualEndDate: "12/28/2023",
    priority: "Medium",
    budget: 22000000,
    cost: 23000000,
    team: [],
  },
  {
    projectName: "Enable Access to All Edges",
    projectOwner: "Ashok",
    status: "Delayed",
    progress: 57,
    startDate: "01/10/2023",
    endDate: "12/10/2023",
    daysLeft: 293,
    group: "Customer Delivery",
    createdOn: "01/03/2023",
    modifiedOn: "01/12/2023",
    createdBy: "Puneet Gaur",
    modifiedBy: "Himanshu Bajpai",
    actualStartDate: "01/25/2023",
    actualEndDate: "12/28/2023",
    priority: "Lowest",
    budget: 22000000,
    cost: 23000000,
    team: [],
  },
  {
    projectName: "Routing with Global Connectivity",
    projectOwner: "Pravin",
    status: "Completed",
    progress: 100,
    startDate: "01/10/2023",
    endDate: "12/10/2023",
    daysLeft: 293,
    group: "Customer Delivery",
    createdOn: "01/03/2023",
    modifiedOn: "01/12/2023",
    createdBy: "Puneet Gaur",
    modifiedBy: "Himanshu Bajpai",
    actualStartDate: "01/25/2023",
    actualEndDate: "12/28/2023",
    priority: "Highest",
    budget: 22000000,
    cost: 23000000,
    team: [],
  },
];

export const breakdownList = [
  {
    id: "Budget Breakdown",
    text: "Budget Breakdown",
  },
  {
    id: "Actual Breakdown",
    text: "Actual Breakdown",
  },
  {
    id: "Forecast Breakdown",
    text: "Forecast Breakdown",
  },
];

export const actualVsForecast = {
  title: {},
  xAxis: {
    type: "category",
    data: ["2022-Q2", "2022-Q3", "2022-Q4", "2023-Q1"],
    axisLabel: {
      color: "#343434",
      fontWeight: "bold",
    },
  },
  yAxis: {
    type: "value",
    axisLabel: {
      formatter: "{value} M",
      fontWeight: "bold",
      color: "#343434",
    },

    splitLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  grid: {
    show: false,
  },
  legend: {
    icon: "circle",
    left: "70%",
    top: "8%",
    itemGap: 8,
    itemWidth: 10,
    itemHeight: 10,
    data: ["Forecast", "Actual"],
    textStyle: {
      fontSize: 12,
      color: "#343434",
    },
  },
  tooltip: {
    trigger: "axis",
  },
  series: [
    {
      data: [110, 132, 101, 120],
      name: "Forecast",
      type: "line",
      symbol: "circle",
      lineStyle: {
        color: "#005199",
        width: 2,
      },
      itemStyle: {
        color: "#005199",
      },
    },
    {
      data: [90, 152, 90, 150],
      name: "Actual",
      type: "line",
      symbol: "circle",
      lineStyle: {
        color: "#5cb3ff",
        width: 2,
      },
      itemStyle: {
        color: "#5cb3ff",
      },
    },
  ],
};

export const resourceList = [
  {
    id: 1,
    startDate: "01/03/2023",
    endDate: "11/11/2023",
    role: "Manager",
    employee: "Ashok Varma Uppalapati",
    status: "Under",
    fte: 0.4,
  },
  {
    id: 2,
    startDate: "01/03/2023",
    endDate: "11/11/2023",
    role: "Developer",
    employee: "Srinath",
    status: "Under",
    fte: 0.4,
  },
];

export const departmentList = [
  { id: "All Departments", text: "All Departments" },
  { id: "Department 1", text: "Department 1" },
  { id: "Department 2", text: "Department 2" },
  { id: "Department 3", text: "Department 3" },
];

export const resourcesByRoles = [
  { role: "Salesforce", count: 5 },
  { role: "Project Manager", count: 1 },
  { role: "Java Developer", count: 5 },
  { role: "DB Manager", count: 2 },
  { role: "UX Designer", count: 2 },
  { role: "UI Developer", count: 5 },
  { role: "QA Engineer", count: 7 },
  { role: "Scrum Master", count: 1 },
];
export const resourcesByLocation = [
  { location: "Austin", count: 15 },
  { location: "Boston", count: 11 },
  { location: "Brussels", count: 15 },
  { location: "Chicago", count: 21 },
  { location: "Dallas", count: 12 },
  { location: "Houston", count: 15 },
  { location: "Los Angeles", count: 13 },
  { location: "California", count: 14 },
];
export const totalResource = [
  {
    value: 15,
    name: "In-House",
  },
  {
    value: 5,
    name: "Vendor",
  },
];

export const resources = [
  {
    value: "Ashok Varma Upplapati - Over",
    label: "Ashok Upplapati - Over",
    skills: ["MSSQL", "ReactJS", "SalesForce", "HTML"],
  },
  {
    value: "Kanishk - Over",
    label: "Kanishk - Over",
    skills: ["MSSQL", "CSS", "SalesForce", "MaterialUI"],
  },
  {
    value: "Srinath - Under",
    label: "Srinath - Under",
    skills: ["MSSQL", "ReactJS", "MySQL", "HTML"],
  },
  {
    value: "Ashutosh - Under",
    label: "Ashutosh - Under",
    skills: ["Java", "AWS", "ReactJS", "JavaScript"],
  },
];

export const skills = [
  { value: "HTML", label: "HTML" },
  { value: "CSS", label: "CSS" },
  { value: "JavaScript", label: "JavaScript" },
  { value: "JQuery", label: "JQuery" },
  { value: "ReactJS", label: "ReactJS" },
  { value: "Angular", label: "Angular" },
  { value: "Java", label: "Java" },
  { value: "MSSQL", label: "MSSQL" },
  { value: "MySQL", label: "MySQL" },
  { value: "MaterialUI", label: "MaterialUI" },
  { value: "BootStrap", label: "BootStrap" },
  { value: "NextJS", label: "NextJS" },
  { value: "SalesForce", label: "SalesForce" },
  { value: "Selenium", label: "Selenium" },
  { value: "Mocha", label: "Mocha" },
  { value: "Jenkins", label: "Jenkins" },
  { value: "AWS", label: "AWS" },
  { value: "Manual Testing", label: "Manual Testing" },
  { value: "Cypress", label: "Cypress" },
  { value: "Docker", label: "Docker" },
  { value: "Kubenetes", label: "Kubenetes" },
  { value: "ASP.Net", label: "ASP.Net" },
  { value: "VB.Net", label: "VB.Net" },
  { value: "VueJS", label: "VueJS" },
  { value: "AI/ML", label: "AI/ML" },
  { value: "Data Analysis", label: "Data Analysis" },
  { value: "Deep Learning", label: "Deep Learning" },
  { value: "Data Visualization", label: "Data Visualization" },
  { value: "Einstein Analytics", label: "Einstein Analytics" },
];

export const allocationdata = [
  {
    System_Code: "Allocation",
    Display_Value: "FTE (0/1)",
  },
  {
    System_Code: "Percantage",
    Display_Value: "Percantage (0/100)",
  },
];

export const resorceAnalyticsData = [
  {
    name: "Kanishk",
    role: "Lead Developer",
    employeeType: "Permanent",
    fte: 0.4,
    utilizationLevel: "Under Utilized",
    location: "California, US",
    standardCost: 1100,
    skills: ["HTML", "CSS", "ReactJS"],
    projects: ["MMSWS", "BCNC", "EAAE"],
    chartData: [10, 120, 150, 70],
  },
  {
    name: "Ashok Varma Upplapati",
    role: "Project Manager",
    employeeType: "Contract",
    fte: 0.8,
    utilizationLevel: "High Utilized",
    location: "Texts, US",
    standardCost: 1300,
    skills: ["HTML", "CSS", "ReactJS"],
    projects: ["MMSWS", "BCNC", "EAAE"],
    chartData: [100, 80, 120, 80],
  },
  {
    name: "Akshay",
    role: "Developer",
    employeeType: "Permanent",
    fte: 0.4,
    utilizationLevel: "Under Utilized",
    location: "California, US",
    standardCost: 2000,
    skills: ["HTML", "CSS", "ReactJS"],
    projects: ["MMSWS", "BCNC", "EAAE"],
    chartData: [40, 20, 50, 70],
  },
  {
    name: "Rishi",
    role: "QA Engineer",
    employeeType: "Contract",
    fte: 1.1,
    utilizationLevel: "Over Utilized",
    location: "Florida, US",
    standardCost: 1000,
    skills: ["HTML", "CSS", "ReactJS"],
    projects: ["MMSWS", "BCNC", "EAAE"],
    chartData: [120, 120, 150, 70],
  },
  {
    name: "Srinath",
    role: "UI Developer",
    employeeType: "Permanent",
    fte: 0.9,
    utilizationLevel: "High Utilized",
    location: "Aukland, NZ",
    standardCost: 1800,
    skills: ["HTML", "CSS", "ReactJS"],
    projects: ["MMSWS", "BCNC", "EAAE"],
    chartData: [100, 120, 150, 70],
  },
];

export const whiteSpaceGraphFilter1Options = [
  {
    System_Code: "ACV Won",
    Display_Value: "ACV Won",
  },
  {
    System_Code: "Average Deal Velocity",
    Display_Value: "Average Deal Velocity",
  },
  {
    System_Code: "Win Ration(Count)",
    Display_Value: "Win Ration(Count)",
  },
  {
    System_Code: "Win Ration(Amount)",
    Display_Value: "Win Ration(Amount)",
  },
  {
    System_Code: "Average Deal Size",
    Display_Value: "Average Deal Size",
  },
  {
    System_Code: "Total Deals Won",
    Display_Value: "Total Deals Won",
  },
];

export const whiteSpaceGraphFilter2Options = [
  {
    System_Code: "Next 12 Months",
    Display_Value: "Next 12 Months",
  },
  {
    System_Code: "Last 12 Months",
    Display_Value: "Last 12 Months",
  },
];

export const financialYearsList = [
  { id: "2023", text: "2023" },
  { id: "2022", text: "2022" },
  { id: "2021", text: "2021" },
  { id: "2020", text: "2020" },
  { id: "2019", text: "2019" },
];

export const internalLabourFilter = [
  { id: "By Project", text: "By Project" },
  { id: "By Location", text: "By Location" },
];

export const vendorExpensesList = [
  { id: "Fixed Price", text: "Fixed Price" },
  { id: "Managed Service", text: "Managed Service" },
  { id: "Other Vendor Expense", text: "Other Vendor Expense" },
  { id: "T&M", text: "T&M" },
];

export const financeViewTypes = [
  { id: "Monthly", text: "Monthly" },
  { id: "Quarterly", text: "Quarterly" },
];

export const heatMapColors = [
  { value: "#06cf06", label: "Green" },
  { value: "#ffff00", label: "Yellow" },
  { value: "#ff0000", label: "Red" },
];

export const financealYears = [
  { id: "2024", text: "2024" },
  { id: "2023", text: "2023" },
  { id: "2022", text: "2022" },
  { id: "2021", text: "2021" },
  { id: "2020", text: "2020" },
];

export const worksheetDesignations = [
  { id: "Architect", text: "Architect" },
  { id: "Project Lead", text: "Project Lead" },
  { id: "Project Manager", text: "Project Manager" },
  { id: "Senior Software Engineer", text: "Senior Software Engineer" },
  { id: "Software Engineer", text: "Software Engineer" },
  { id: "Software Analyst", text: "Software Analyst" },
];

export const worksheetOnsiteOffshore = [
  { id: "Onsite", text: "Onsite" },
  { id: "Offshore", text: "Offshore" },
];

export const dateFormats = [
  { id: "DD/MM/YY", text: "DD/MM/YY" },
  { id: "DD-MM-YY", text: "DD-MM-YY" },
  { id: "DD/MM/YYYY", text: "DD/MM/YYYY" },
  { id: "DD-MM-YYYY", text: "DD-MM-YYYY" },
  { id: "MM/DD/YY", text: "MM/DD/YY" },
  { id: "MM-DD-YY", text: "MM-DD-YY" },
  { id: "MM/DD/YYYY", text: "MM/DD/YYYY" },
  { id: "MM-DD-YYYY", text: "MM-DD-YYYY" },
  { id: "YYYY/MM/DD", text: "YYYY/MM/DD" },
  { id: "YYYY-MM-DD", text: "YYYY-MM-DD" },
];

export const months = [
  { id: "January", text: "January" },
  { id: "February", text: "February" },
  { id: "March", text: "March" },
  { id: "April", text: "April" },
  { id: "May", text: "May" },
  { id: "June", text: "June" },
  { id: "July", text: "July" },
  { id: "August", text: "August" },
  { id: "September", text: "September" },
  { id: "October", text: "October" },
  { id: "November", text: "November" },
  { id: "December", text: "December" },
];

export const timeZones = [
  { id: "Asia - India", text: "Asia – India" },
  { id: "Central US – CET", text: "Central US – CET" },
  { id: "Eastern - EST", text: "Eastern - EST" },
  { id: "Europe – Belgium", text: "Europe – Belgium" },
  { id: "London", text: "London" },
  { id: "Pacific US – PT", text: "Pacific US – PT" },
];

export const onsiteOffshoreList = [
  { value: "Onsite", label: "Onsite" },
  { value: "Offshore", label: "Offshore" },
];

export const adminPermissionRoles = [
  { value: "Admin", label: "Admin" },
  { value: "CIO", label: "CIO" },
  { value: "Projects Manager", label: "Projects Manager" },
  { value: "Resource Manager", label: "Resource Manager" },
];

export const created_by = localStorage.getItem("Login_User_Name");

export const monthsList = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const sortItems = [
  { id: "asc", text: "A to Z" },
  { id: "desc", text: "Z to A" },
];

export const sortItemsDates = [
  { id: "asc", text: "Oldest to Newest" },
  { id: "desc", text: "Newest to Oldest" },
];

export const sortItemsNumbers = [
  { id: "asc", text: "Lowest to Highest" },
  { id: "desc", text: "Highest to Lowest" },
];

export const aggregateTypes = [
  { label: "Department", value: "Department" },
  { label: "Project", value: "Project" },
  { label: "Project Owner", value: "Project Owner" },
  { label: "Utilization", value: "Utilization" },
];
export const filterSearchTypeListSelect = [
  {
    id: "Contains",
    text: "Contains",
  },
  {
    id: "Does Not Contains",
    text: "Does Not Contains",
  },
];
export const filterSearchTypeListDates = [
  {
    id: "Equals",
    text: "Equals",
  },
  {
    id: "Does Not Equal",
    text: "Does Not Equal",
  },
  {
    id: "Before",
    text: "Before",
  },
  {
    id: "After",
    text: "After",
  },
  {
    id: "Between",
    text: "Between",
  },
];
export const loginAPIHeaders = {
  "Content-Type": "application/json; charset=utf-8",
};

export const otherAPIHeaders = {
  "Content-Type": "application/json; charset=utf-8",
  username: localStorage.getItem("Login_User_Name"),
  accessToken: localStorage.getItem("token"),
  email: localStorage.getItem("email"),
  role: localStorage.getItem("roles")
    ? JSON.parse(localStorage.getItem("roles")).join(",")
    : ``,
};

export const testAPIHeaders = {
  username: "kv",
  accessToken: 1,
  role: "RM",
  "Content-Type": "application/json; charset=utf-8",
};

export const ssoHeaders = {
  "Content-Type": "application/json",
  "access-control-allow-origin": "*",
  " access-control-expose-headers": "*",
  "cache-control": "no-cache,no-store,max-age=0,must-revalidate ",
  connection: "close",
  expires: 0,
  pragma: "no-cache",
  "strict-transport-security": "max-age=31536000 ; includeSubDomains",
  "transfer-encoding": "chunked",
  vary: "Origin,Access-Control-Request-Method,Access-Control-Request-Headers",
  "x-content-type-options": "nosniff",
  "x-frame-options": "DENY",
  "x-xss-protection": "1; mode=block",
};

export const uploadAPIHeaders = {
  username: localStorage.getItem("Login_User_Name"),
  accessToken: localStorage.getItem("token"),
  email: localStorage.getItem("email"),
  role: localStorage.getItem("roles")
    ? JSON.parse(localStorage.getItem("roles")).join(",")
    : ``,
};

export const unnamedSearchFilters = {
  data: {
    searchFilters: {
      resourceName: "",
      roles: "11",
      skills: "",
      empLocation: "",
      employeeType: "",
      startDate: "2023-10-02",
      endDate: "2023-10-20",
    },
    ganttChartData: {
      projectId: 135,
      projectName: "Edit Testing 1",
      allocationStartDate: "2023-10-30",
      allocationEndDate: "2023-10-31",
      isUpdated: false,
      allocationData: [
        {
          id: 13825,
          mapId: 474,
          allocationDate: "2023-10-19",
          fte: 1.2,
          requestedFte: 0.5,
        },
        {
          id: 13826,
          mapId: 474,
          allocationDate: "2023-10-31",
          fte: 1.2,
          requestedFte: 0.5,
        },
      ],
      weeklyAllocations: [
        {
          week: "2023-10-09",
          year: 2023,
          averageToShow: 1.2,
          averageRequestedToShow: 1.5,
          thisWeekAllocationData: [
            {
              id: 13825,
              mapId: 474,
              allocationDate: "2023-10-30",
              fte: 1.2,
              requestedFte: 0.5,
            },
            {
              id: 13826,
              mapId: 474,
              allocationDate: "2023-10-31",
              fte: 1.2,
              requestedFte: 0.4,
            },
          ],
        },
      ],
      monthlyAllocations: [
        {
          month: "OCTOBER",
          year: 2023,
          averageToShow: 1.2,
          averageRequestedToShow: 0.5,
          thisMonthAllocationData: [
            {
              id: 13825,
              mapId: 474,
              allocationDate: "2023-10-30",
              fte: 1.2,
              requestedFte: 0.5,
            },
            {
              id: 13826,
              mapId: 474,
              allocationDate: "2023-10-31",
              fte: 1.2,
              requestedFte: 0.4,
            },
          ],
        },
      ],
    },
  },
};

export const accessRoles = [
  { label: "Admin", value: "ADMIN" },
  { label: "Manager", value: "MANAGER" },
  { label: "Resource Manager", value: "RM" },
];

export const emailSettingOptions = [
  { label: "Daily Summary", value: "Daily" },
  { label: "Weekly Summary", value: "Weekly" },
  { label: "Opt Out", value: "Opt Out" },
];

export const managerWeeks = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
];

export const pmWeeks = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
];

export const pipelineStages = [
  { label: "Identify", value: "Identify" },
  { label: "Qualify", value: "Qualify" },
  { label: "Pursue", value: "Pursue" },
  { label: "Proposal", value: "Proposal" },
  { label: "Submitted", value: "Submitted" },
  { label: "Protest", value: "Protest" },
  { label: "Closed Won", value: "Closed Won" },
  { label: "Closed Lost", value: "Closed Lost" },
  { label: "No Bid", value: "No Bid" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Pricing Submitted", value: "Pricing Submitted" },
];

export const emailSettingsTimeZones = [
  { label: "PT", value: "PT" },
  { label: "CT", value: "CT" },
  { label: "ET", value: "ET" },
  { label: "GMT/UTC", value: "UTC" },
  { label: "IST", value: "IST" },
  { label: "HKT", value: "HKT" },
];

export const reports = [
  {
    label: "Projects Without Resource Requests",
    value: "crp",
  },
  {
    label: "Manager Actions Needed for Resource Requests",
    value: "crm",
  },
  { label: "User Login History", value: "ua" },
];

export const expenseTypes = [
  { label: "Travel", value: "Travel" },
  { label: "ODC", value: "ODC" },
  { label: "Subcontract", value: "Subcontract" },
  { label: "Materials", value: "Materials" },
];

export const PLData = {
  plData: [
    {
      id: 1,
      includeInForecast: "Yes",
      salesforceOrManual: "Salesforce",
      federal: "",
      opportunityNumber: "SFOP001",
      opportunityName: "New Product Launch",
      closedDate: "2026-10-22",
      forecastCategory: "Commit",
      revenue: 17500000,
      directLabor: 21,
      subContractor: 15,
      grossProfit: 1025300,
      odcs: 2,
      indirectCosts: 4,
      netMargin: 58,
    },
    {
      id: 2,
      includeInForecast: "Yes",
      salesforceOrManual: "Manual",
      federal: "",
      opportunityNumber: "MLOP002",
      opportunityName: "Strategic Partnership C",
      closedDate: "2026-08-14",
      forecastCategory: "Pipeline",
      revenue: 120000,
      directLabor: 12,
      subContractor: 8,
      grossProfit: 1025300,
      odcs: 1,
      indirectCosts: 1,
      netMargin: 33,
    },
  ],
  adjustment: { revenue: 2500000 },
};

export const includeForecastOptions = [
  { id: true, text: "Yes", label: "Yes", value: true },
  { id: false, text: "No", label: "No", value: false },
];

export const forecastCategoryOptions = [
  { id: "Pipeline", text: "Pipeline", label: "Pipeline", value: "Pipeline" },
  {
    id: "Best Case",
    text: "Best Case",
    label: "Best Case",
    value: "Best Case",
  },
  { id: "Closed", text: "Closed", label: "Closed", value: "Closed" },
  { id: "Omitted", text: "Omitted", label: "Omitted", value: "Omitted" },
];

export const opportunityData = {
  monthlyHeaders: [
    "Jan - 2025",
    "Feb - 2025",
    "Mar - 2025",
    "Apr - 2025",
    "May - 2025",
    "Jun - 2025",
    "Jul - 2025",
    "Aug - 2025",
    "Sept - 2025",
    "Oct - 2025",
    "Nov - 2025",
    "Dec - 2025",
  ],
  data: [
    {
      type: "Revenue",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Total Direct Cost",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Direct Labor",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Subcontractor",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "ODCs",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Gross Profit",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Gross Margin%",
      values: [12, 31, 44, 12, 33, 43, 51, 12, 23, 34, 45, 56],
      format: "percentage",
    },
    {
      type: "Burdened Cost",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Net Profit",
      values: [
        100000, 120000, 150000, 130000, 140000, 160000, 170000, 180000, 190000,
        200000, 210000, 220000,
      ],
      format: "currency",
    },
    {
      type: "Net Profit %",
      values: [12, 31, 44, 12, 33, 43, 51, 12, 23, 34, 45, 56],

      format: "percentage",
    },
  ],
};

export const transitionTimeValues = [
  { label: 0, value: 0 },
  { label: 15, value: 15 },
  { label: 30, value: 30 },
  { label: 60, value: 60 },
  { label: 90, value: 90 },
];

export const opportunityFields = [
  {
    id: "includeInForecastText",
    text: "Include in Forecast",
    fieldType: "Picklist",
    list: ["Yes", "No"],
  },
  {
    id: "salesforce_manual_data",
    text: "Salesforce/Manual Data",
    fieldType: "Text",
    list: [],
  },
  {
    id: "federal",
    text: "Federal",
    fieldType: "Text",
    list: [],
  },
  {
    id: "existingProjectId",
    text: "Existing Project ID",
    fieldType: "Text",
    list: [],
  },
  {
    id: "oppNo1",
    text: "Opportunity Number",
    fieldType: "Text",
    list: [],
  },
  {
    id: "oppName",
    text: "Opportunity Name",
    fieldType: "Text",
    list: [],
  },
  {
    id: "sector",
    text: "Sector",
    fieldType: "Text",
    list: [],
  },
  {
    id: "businessUnit",
    text: "Business Unit",
    fieldType: "Text",
    list: [],
  },
  {
    id: "opportunityType",
    text: "Opportunity Type",
    fieldType: "Text",
    list: [],
  },
  {
    id: "accountName",
    text: "Account Name",
    fieldType: "Text",
    list: [],
  },
  {
    id: "closedDate",
    text: "Closed Date",
    fieldType: "Date",
    list: [],
  },
  {
    id: "forecastCategory",
    text: "Forecast Category",
    fieldType: "Text",
    list: ["Pipeline", "Best Case", "Omitted", "Closed"],
  },
  {
    id: "contractType",
    text: "Contract Type",
    fieldType: "Picklist-Multiselect",
    list: [],
  },
  {
    id: "awardType",
    text: "Award Type",
    fieldType: "Text",
    list: [],
  },
  {
    id: "competitionType",
    text: "Competition Type",
    fieldType: "Text",
    list: [],
  },
  {
    id: "endCustomer",
    text: "End Customer",
    fieldType: "Text",
    list: [],
  },
  {
    id: "revenue",
    text: "Revenue",
    fieldType: "Currency",
    list: [],
  },
  {
    id: "transitionCost",
    text: "Transition Cost",
    fieldType: "Currency",
    list: [],
  },
  {
    id: "directLaborPct",
    text: "Direct Labor%",
    fieldType: "Number",
    list: [],
  },
  // {
  //   id: "directLaborWrapFee",
  //   text: "Direct Labor Wrap w/fee",
  //   fieldType: "Number",
  //   list: [],
  // },
  {
    id: "subcontractPct",
    text: "Subcontractor%",
    fieldType: "Number",
    list: [],
  },
  // {
  //   id: "subcontractWrapFee",
  //   text: "Subcontractor Wrap w/fee",
  //   fieldType: "Number",
  //   list: [],
  // },
  {
    id: "odcPct",
    text: "ODCs%",
    fieldType: "Number",
    list: [],
  },
  {
    id: "grossProfit",
    text: "Gross Profit",
    fieldType: "Currency",
    list: [],
  },
  {
    id: "grossProfitPct",
    text: "Gross Profit%",
    fieldType: "Number",
    list: [],
  },

  // {
  //   id: "odcWrapFee",
  //   text: "ODC Wrap w/fee",
  //   fieldType: "Number",
  //   list: [],
  // },
  {
    id: "indirectCostPct",
    text: "Indirect Costs%",
    fieldType: "Number",
    list: [],
  },
  {
    id: "netMarginPct",
    text: "Net Margin%",
    fieldType: "Number",
    list: [],
  },

  {
    id: "rvnEscalationPct",
    text: "Annual Escalation %",
    fieldType: "Number",
    list: [],
  },
];

export const costRateTypes = [
  { label: "Cost Rate (Unloaded)", value: "U" },
  { label: "Cost Rate (Loaded)", value: "L" },
];

export const hourTypes = [
  { label: "Hours", value: "H" },
  { label: "OT Hours", value: "O" },
];

export const yesNoDdl = [
  { label: "Yes", value: true, id: true, text: "Yes" },
  { label: "No", value: false, id: false, text: "No" },
];
